/**
 * @generated SignedSource<<fbe8c2c79a94c4a780ae7d8f53d6d668>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type authorBlockPrintArticleArticle$data = {
  readonly " $fragmentSpreads": FragmentRefs<"authorNamesArticle" | "defaultArticleDateContent">;
  readonly " $fragmentType": "authorBlockPrintArticleArticle";
};
export type authorBlockPrintArticleArticle$key = {
  readonly " $data"?: authorBlockPrintArticleArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"authorBlockPrintArticleArticle">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "authorBlockPrintArticleArticle",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "defaultArticleDateContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "authorNamesArticle"
    }
  ],
  "type": "Article",
  "abstractKey": null
};

(node as any).hash = "8078af989f3b072dde4a6971b1842b59";

export default node;
